import React from 'react';
import { Trash } from '@phosphor-icons/react';
import { SettingsLine } from './SettingsLine';

interface ChatSectionProps {
  onDeleteAllChats: () => void;
}

export function ChatSection({ onDeleteAllChats }: ChatSectionProps) {
  return (
    <div>
      <h3 className="text-xs font-semibold uppercase tracking-wider text-[#361e06] mb-4">Chat History</h3>
      
      <div>
        <SettingsLine 
          label="Delete chat history" 
          icon={Trash}
          isLast={true}
        >
          <button
            onClick={onDeleteAllChats}
            className="text-sm font-medium text-red-600 hover:text-red-700"
          >
            Delete all chats
          </button>
        </SettingsLine>
      </div>
    </div>
  );
}
